// extracted by mini-css-extract-plugin
var _1 = "_goldConversionApprovalTable-module__action-button";
var _2 = "_goldConversionApprovalTable-module__action-button-container";
var _3 = "_goldConversionApprovalTable-module__approve";
var _4 = "_goldConversionApprovalTable-module__gold-row";
var _5 = "_goldConversionApprovalTable-module__reject";
var _6 = "_goldConversionApprovalTable-module__transaction-action-label";
export { _1 as "action-button", _2 as "action-button-container", _3 as "approve", _4 as "gold-row", _5 as "reject", _6 as "transaction-action-label" }
